import {AuthenticationResult, EventType, PublicClientApplication} from "@azure/msal-browser";
import {loginRequest, msalConfig} from "./authConfig";
import {MsalProvider} from "@azure/msal-react";
const msalInstance = new PublicClientApplication(msalConfig);
const storeOriginalUrl = () => {
  const account = msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0];

  if (!account && !sessionStorage.getItem("redirectAfterLogin")) {
    sessionStorage.setItem("redirectAfterLogin", window.location.pathname + window.location.search);
  }
};


export const acquireAccessToken = async () => {
  await msalInstance.initialize();
  
  const account = msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0];
  
  if (!account) {
    console.error('No account found for token acquisition');
    throw new Error('No authenticated account found');
  }
  
  
  try {
    const authResult = await msalInstance.acquireTokenSilent({account: account, ...loginRequest});
    return authResult.accessToken;
  } catch (error) {
    console.error('Error acquiring token:', error);
    throw error;
  }
}


export const AuthProvider = ({children}) => {
  storeOriginalUrl();
  const account = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];

  if (account) {
    msalInstance.setActiveAccount(account);
  }

// Listen for sign-in event and set active account
  msalInstance.addEventCallback((event) => {
    const authResult = event.payload as AuthenticationResult;
    const account = authResult?.account;
    if (event.eventType === EventType.LOGIN_SUCCESS && account) {
      msalInstance.setActiveAccount(account);

      // Retrieve the stored URL
      const redirectPath = sessionStorage.getItem("redirectAfterLogin");

      // Ensure we don't get stuck in an infinite loop
      if (redirectPath && window.location.pathname !== redirectPath) {
        sessionStorage.removeItem("redirectAfterLogin");
        window.location.replace(redirectPath);
      }
    }
  });

  return (
    <MsalProvider instance={msalInstance}>
      {children}
    </MsalProvider>)
}

export function useAuthProvider() {
  return {AuthProvider};
}
